import { render, staticRenderFns } from "./item.vue?vue&type=template&id=06febf5c"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06febf5c')) {
      api.createRecord('06febf5c', component.options)
    } else {
      api.reload('06febf5c', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=06febf5c", function () {
      api.rerender('06febf5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/placeholder/item.vue"
export default component.exports